import 'twin.macro';
import React from 'react';
import { PlusIcon as Plus } from '@heroicons/react/24/outline';
import { Menu } from '@teetsh/app/src/components/Menu';
import { useTranslation } from 'react-i18next';

interface Props {
  headers: Array<{ id: string; label: string }>;
  onAdd: (v: string) => void;
}

export function AddFilterButton(props: Props) {
  const { headers } = props;
  const { t } = useTranslation(['common']);
  return (
    <div data-testid="add-filter-options">
      <Menu>
        <Menu.Button
          className="group"
          icon={Plus}
          minimal
          tw="text-muted font-medium"
          small
          aria-label="Ajouter un filtre"
        >
          {t('common:buttons.add')}
        </Menu.Button>
        <Menu.Items>
          {headers.map(b => (
            <Menu.Item
              onClick={() => props.onAdd(b.id)}
              key={b.id}
              tw="whitespace-nowrap"
              text={b.label}
              aria-label={`Élément ${b.label}`}
            />
          ))}
        </Menu.Items>
      </Menu>
    </div>
  );
}
